import type { Messages } from '@lingui/core'
import { i18n } from '@lingui/core'

export type LoadMessages = (language: GLOBALS.Language) => Promise<Messages>

type Config = {
  language: GLOBALS.Language
  loadMessages: LoadMessages
}

export const setupI18n = async ({ language = 'en', loadMessages }: Config) => {
  const messages = await loadMessages(language)
  i18n.load(language, messages)
  i18n.activate(language)
}
